import StringUtils from '../utils/StringUtils';

const expressionTypeNetTotal = 'NetTotal';
const expressionTypeEimTotal = 'EimTotal';
const expressionTypeCommonEngineTotal = 'CommonEngineTotal';

const shapeProfileEnergy = 'Energy';
const shapeProfileTransmission = 'Transmission';
const shapeProfileBoth = 'Both';

const marketTypeNone = 'None';
const marketTypeRealtime = 'Realtime';
const marketTypePreschedule = 'Preschedule';

const resolutionWaterfallTagCodeDesc = 'WaterfallTagCodeDescending';
const resolutionWaterfallTagCodeAsc = 'WaterfallTagCodeAscending';
const resolutionWaterfallTransSizeDesc = 'WaterfallTransmissionSizeDescending';
const resolutionWaterfallTransSizeAsc = 'WaterfallTransmissionSizeAscending';
const resolutionProrata = 'Prorata';

const delimiter = "|";

export default class SataConfigurationUtils {
  static getExpressionTypeOptions() {
    return [
      expressionTypeNetTotal,
      expressionTypeEimTotal,
      expressionTypeCommonEngineTotal
    ];
  }

  static getShapeProfileOptions() {
    return [
      shapeProfileEnergy,
      shapeProfileTransmission,
      shapeProfileBoth
    ];
  }

  static getMarketTypes() {
    return [
      marketTypeNone,
      marketTypeRealtime,
      marketTypePreschedule
    ];
  }

  static getResolutionStrategies() {
    return [{
        displayName: 'Waterfall (Tag Code Descending)',
        enumValue: resolutionWaterfallTagCodeDesc
      }, {
        displayName: 'Waterfall (Tag Code Ascending)',
        enumValue: resolutionWaterfallTagCodeAsc
      }, {
        displayName: 'Waterfall (Transmission Size Descending)',
        enumValue: resolutionWaterfallTransSizeDesc
      }, {
        displayName: 'Waterfall (Transmission Size Ascending)',
        enumValue: resolutionWaterfallTransSizeAsc
      }, {
        displayName: 'Prorata',
        enumValue: resolutionProrata
      }
    ];
  }

  static deserializeValues(value) {
    if (!StringUtils.isNonEmptyString(value))
      return null;

    var index = value.indexOf(delimiter);
    if (index < 1)
      return null;

    var expressionName = value.substring(0, index);
    value = value.substring(index + 1);

    index = value.indexOf(delimiter);
    if (index < 1)
      return null;

    var expressionType = value.substring(0, index);
    value = value.substring(index + 1);

    index = value.indexOf(delimiter);
    if (index < 1)
      return null;

    var shapeProfile = value.substring(0, index);
    value = value.substring(index + 1);

    index = value.indexOf(delimiter);
    if (index < 1)
      return null;

    return {
      expressionName: expressionName,
      expressionType: expressionType,
      shapeProfile: shapeProfile,
      marketType: value.substring(0, index),
      resolutionStrategy: value.substring(index + 1)
    };
  }

  static serializeValues(expressionName, expressionType, shapeProfile, marketType, resolutionStrategy) {
    return `${expressionName}${delimiter}` +
      `${expressionType}${delimiter}` +
      `${shapeProfile}${delimiter}` +
      `${marketType}${delimiter}` +
      `${resolutionStrategy}`;
  }
}